import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import LogoSection from './components/LogoSection';
import PricingSection from './components/PricingSection';
import Footer from './components/Footer';

function App() {
  return (
    <div className="min-h-screen relative overflow-hidden font-sans" style={{backgroundColor: '#030014'}}>
      {/* Reflect.app-inspired base gradient */}
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(100% 146.88% at 100% 100%, rgba(255,255,255,.03) 0%, rgba(3,0,20,0) 100%)'
      }}></div>
      
      {/* Animated starfield background */}
      <div className="absolute inset-0 opacity-60">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='1920' height='1080' viewBox='0 0 1920 1080' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,-100;0,0' dur='20s' repeatCount='indefinite'/%3E%3C/defs%3E%3Cg fill='%23ffffff' opacity='0.3'%3E%3Ccircle cx='158' cy='45' r='1'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='15s' repeatCount='indefinite'/%3E%3C/circle%3E%3Ccircle cx='300' cy='120' r='1.5'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='25s' repeatCount='indefinite'/%3E%3C/circle%3E%3Ccircle cx='500' cy='80' r='0.8'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='18s' repeatCount='indefinite'/%3E%3C/circle%3E%3Ccircle cx='750' cy='200' r='1.2'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='22s' repeatCount='indefinite'/%3E%3C/circle%3E%3Ccircle cx='900' cy='60' r='0.6'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='28s' repeatCount='indefinite'/%3E%3C/circle%3E%3Ccircle cx='1200' cy='150' r='1.8'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='30s' repeatCount='indefinite'/%3E%3C/circle%3E%3Ccircle cx='1500' cy='90' r='1'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='20s' repeatCount='indefinite'/%3E%3C/circle%3E%3Ccircle cx='1800' cy='180' r='1.4'%3E%3CanimateTransform attributeName='transform' type='translate' values='0,0;0,1080;0,0' dur='35s' repeatCount='indefinite'/%3E%3C/circle%3E%3C/g%3E%3C/svg%3E")`,
          backgroundRepeat: 'repeat',
          animation: 'drift 40s linear infinite'
        }}></div>
      </div>
      
      {/* Deep purple radial gradients inspired by Reflect */}
      <div className="absolute top-0 left-0 w-full h-full" style={{
        background: 'radial-gradient(50% 50% at 50% 50%, rgba(139, 69, 219, 0.1) 0%, transparent 50%)'
      }}></div>
      
      {/* Dynamic floating orbs */}
      <div className="absolute top-1/4 right-1/3 w-[600px] h-[600px] rounded-full animate-pulse" style={{
        background: 'radial-gradient(circle, rgba(139, 69, 219, 0.15) 0%, rgba(139, 69, 219, 0.05) 40%, transparent 70%)',
        filter: 'blur(40px)',
        animation: 'float 8s ease-in-out infinite'
      }}></div>
      
      <div className="absolute bottom-1/3 left-1/4 w-[800px] h-[800px] rounded-full" style={{
        background: 'radial-gradient(circle, rgba(168, 85, 247, 0.12) 0%, rgba(168, 85, 247, 0.03) 50%, transparent 70%)',
        filter: 'blur(60px)',
        animation: 'float 12s ease-in-out infinite reverse'
      }}></div>
      
      {/* Subtle noise texture */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
      }}></div>
      
      {/* Top gradient overlay */}
      <div className="absolute top-0 left-0 right-0 h-40" style={{
        background: 'linear-gradient(180deg, rgba(3,0,20,0.8) 0%, transparent 100%)'
      }}></div>
      
      <Header />
      <main className="relative z-10">
        <Hero />
        <LogoSection />
        <PricingSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
